import React from 'react'

export const PageNotFound = () => {
  return (
    <main>PageNotFound</main>
  )
}
